import script from "./factory-testing.vue?vue&type=script&lang=ts&setup=true"
export * from "./factory-testing.vue?vue&type=script&lang=ts&setup=true"

import "./factory-testing.vue?vue&type=style&index=0&id=832395d2&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-832395d2"]])

export default __exports__